import React, { useState } from 'react';
import './CandidateRating.css';

interface CandidateRatingProps {
  candidateId: string;
  candidateName: string;
  showDetails?: boolean;
  darkMode?: boolean;
}

const CandidateRating: React.FC<CandidateRatingProps> = ({ 
  candidateId, 
  candidateName,
  showDetails = false,
  darkMode = false 
}) => {
  const [showExplanation, setShowExplanation] = useState(false);

  // Always show coming soon for now
  return (
    <>
      <div 
        className={`candidate-rating-container ${darkMode ? 'dark' : 'light'} coming-soon clickable`}
        onClick={() => setShowExplanation(true)}
        title="Click to learn more about candidate match rating"
      >
        <div className="rating-label">Candidate Match Rating</div>
        <div className="rating-summary disabled">
          <div className="quality-score coming-soon-score">
            <span className="score-value">--</span>
            <span className="score-label">Coming Soon</span>
          </div>
        </div>
      </div>

      {showExplanation && (
        <div className="modal-overlay" onClick={() => setShowExplanation(false)}>
          <div className={`rating-explanation-modal ${darkMode ? 'dark' : 'light'}`} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Candidate Match Rating</h2>
              <button className="close-btn" onClick={() => setShowExplanation(false)}>
                <span className="material-icons">close</span>
              </button>
            </div>
            
            <div className="modal-content">
              <div className="feature-overview">
                <div className="feature-icon">
                  <span className="material-icons" style={{ fontSize: '64px' }}>insights</span>
                </div>
                <h3>AI-Powered Candidate Evaluation</h3>
                <p>Our advanced matching algorithm will analyze multiple factors to provide you with an accurate assessment of each candidate.</p>
              </div>

              <div className="features-grid">
                <div className="feature-item">
                  <h4><span className="material-icons">grade</span> Match Score (0-100)</h4>
                  <p>Overall compatibility score based on skills, experience, and company requirements</p>
                </div>
                
                <div className="feature-item">
                  <h4><span className="material-icons">trending_up</span> Success Prediction</h4>
                  <p>Likelihood of successful placement based on historical data and patterns</p>
                </div>
                
                <div className="feature-item">
                  <h4><span className="material-icons">psychology</span> Skill Alignment</h4>
                  <p>Detailed breakdown of how candidate skills match job requirements</p>
                </div>
                
                <div className="feature-item">
                  <h4><span className="material-icons">show_chart</span> Career Trajectory</h4>
                  <p>Analysis of career progression and growth potential</p>
                </div>
                
                <div className="feature-item">
                  <h4><span className="material-icons">warning</span> Risk Assessment</h4>
                  <p>Identify potential red flags based on application patterns</p>
                </div>
                
                <div className="feature-item">
                  <h4><span className="material-icons">lightbulb</span> Recommendations</h4>
                  <p>Actionable insights on whether to proceed with the referral</p>
                </div>
              </div>

              <div className="coming-soon-notice">
                <p>This feature is currently in development and will be available soon. It will help you make informed decisions about referral requests by providing data-driven insights.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CandidateRating;